import axiosClient from '@clients/axiosClient';
import { BaseTypes } from '@utils/URLs';

interface GetDelinquencies {
    accountId: number;
    page: number;
    perPage: number;
}

const backendForFrontend = () => {
    const client = axiosClient({ baseType: BaseTypes.BFF });
    return {
        async getDelinquencies({ accountId, page, perPage }: GetDelinquencies) {
            const { data } = await client.post(`query`, {
                query: `query delinquency($accountId: Int!=${accountId}, $page: Int=${page}, $perPage: Int=${perPage}) { search_delinquencies(accountId: $accountId, page: $page, perPage: $perPage) { current_page, per_page, total_items, items_on_page, pages, is_last_page, items {statement_id, statement_cycle, delinquencyBucket_id, bucket_amount, bucket_balance, created_at, updated_at, calculation_memory { strategy, mad, overdue_amount, previous_bucket_balance }}}}`,
            });
            return data;
        },
    };
};

export default backendForFrontend;
